import config from '@/models/services/config';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import * as CT from '@/models/services/collegetransfer/entities';

export default class Client {
	public async checkIn(): Promise<CT.IWillMyCreditsTransferCheckInResponse> {
		const axiosRequest = {
			method: 'post',
			data: {
				UnitId: config.TargetUnitId,
				HttpReferrer: config.HttpReferrer,
			},
			url: config.ApiUrl + 'Searches/WmctWidgetCheckIn',
			headers: {
				'Api-Key': config.ApiKey,
			},
		};

		return await axios<never, CT.IWillMyCreditsTransferCheckInResponse>(axiosRequest).then((resp) => {
			return resp.data;
		});
	}

	public async willMyCreditsTransfer(request: CT.IWillMyCreditsTransferRequest)
		: Promise<CT.IWillMyCreditsTransferResponse> {
		const axiosRequest = {
			method: 'post',
			data: request,
			url: config.ApiUrl + 'Searches/WillMyCreditsTransfer',
			headers: {
				'Api-Key': config.ApiKey,
			},
		};

		return await axios<never, CT.IWillMyCreditsTransferResponse>(axiosRequest).then((resp) => {
			return resp.data;
		});
	}


}
